import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CityHero from '../../components/feature/CityHero';
import Services from '../home/components/Services';
import Testimonials from '../home/components/Testimonials';
import Contact from '../home/components/Contact';
import FAQ from '../home/components/FAQ';

export default function ReparationFenetreSainteFoyLesLyon() {
  useEffect(() => {
    document.title = 'Sainte-Foy-lès-Lyon Réparation Fenêtres Fenêtres Lyon | Expert Fenêtres';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Sainte-Foy-lès-Lyon Réparation Fenêtres Fenêtres Lyon - Service professionnel de réparation de fenêtres à Sainte-Foy-lès-Lyon. Intervention rapide, devis gratuit. Spécialiste fenêtres PVC, alu, bois. Appelez-nous !');
    }
  }, []);

  return (
    <>
      <div className="min-h-screen bg-white">
        <Navbar />
        <CityHero 
          cityName="Sainte-Foy-lès-Lyon"
          imageSeq="sainte-foy-les-lyon-hero-013"
        />
        <Services />
        <Testimonials />
        <Contact />
        <FAQ />
        <Footer />
      </div>
    </>
  );
}
